/**
 * Pulls a named object sent from the server for use in the client-side
 * from the ClientDataStore
 * @template {any} T    The type of the object to be parsed.
 * @param {string} name Key of the object put into the ClientDataStore
 * @returns {T|undefined} The parsed object or undefined if not found.
 */
export function parseClientDataStore<
	T extends object | (string | number | boolean | object)[],
	TStoreModel = T extends (infer U)[] ? U[] : T,
>(name: string): TStoreModel | undefined {
	try {
		const el = document.getElementById(`client-data-store-${name}`);
		if (el && el.innerText) {
			const parsedData = JSON.parse(el.innerText) as TStoreModel;
			window.awxLogger
				?.withScope(`tagEngine::parseClientDataStore::${name}`)
				.debug('Successfully parsed store data', parsedData);
			return parsedData;
		}
	} catch (e) {
		window.awxLogger
			?.withScope(`tagEngine::parseClientDataStore::${name}`)
			.error(`Could not parse client data store '${name}'`, e);
	}

	window.awxLogger
		?.withScope(`tagEngine::parseClientDataStore::${name}`)
		.debug(
			`${name}: Could not parse JSON data, likely missing client-data-store element.`,
		);
}
